"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearAutoAITask = clearAutoAITask;
exports.stopAutoAIPolling = stopAutoAIPolling;
exports.startAutoAIPolling = startAutoAIPolling;
exports.getAutoAITaskResponse = getAutoAITaskResponse;
exports.disableAutoAIBtn = disableAutoAIBtn;
exports.initFooterAutoButtonClick = initFooterAutoButtonClick;
const autoAIRequest_1 = require("../../../requests/autoAIRequest");
const errors_1 = __importDefault(require("../../../js/errors"));
const autoAI_1 = require("./model/autoAI");
const summary_lib_1 = require("../../../js/summary_lib");
const periodTypes_1 = __importDefault(require("../../../table/v1/periodTypes"));
function clearAutoAITask() {
    stopAutoAIPolling();
    disableAutoAIBtn(false);
}
let autoAIPollTimer = null;
function stopAutoAIPolling() {
    if (autoAIPollTimer) {
        clearTimeout(autoAIPollTimer);
    }
    autoAIPollTimer = null;
}
function startAutoAIPolling(userId, branchId, list, start, end, onDone, intervalMs = 30000) {
    stopAutoAIPolling();
    disableAutoAIBtn(true);
    const tick = async () => {
        try {
            const res = await getAutoAITaskResponse(userId, branchId, list, start, end);
            if (res.state === undefined) {
                clearAutoAITask();
                return;
            }
            if (res.state === autoAI_1.TaskState.Done) {
                clearAutoAITask();
                onDone?.(res.notesJapanese);
                return;
            }
            else if (res.state === autoAI_1.TaskState.Error || res.stale) {
                throw new Error();
            }
        }
        catch (err) {
            clearAutoAITask();
            (0, summary_lib_1.openAlertModal)(errors_1.default.AUTOAI.CREATE);
            // return;
        }
        autoAIPollTimer = setTimeout(tick, intervalMs);
    };
    autoAIPollTimer = setTimeout(tick, 0);
}
function extractNotesFromOutput(output) {
    try {
        // Parse the outer OpenAI response JSON stored in task.Output
        const outer = JSON.parse(output);
        const content = outer?.choices?.[0]?.message?.content;
        // Parse the inner JSON string in message.content
        const inner = JSON.parse(content);
        const notesJapanese = inner?.NotesJapanese;
        return notesJapanese;
    }
    catch {
        return "";
    }
}
function isTaskStale(created) {
    const createdMs = Date.parse(created);
    const msFromCreation = Date.now() - createdMs;
    return msFromCreation > 60000;
}
async function getAutoAITaskResponse(userId, branchId, list, start, end) {
    try {
        let response;
        if (list === periodTypes_1.default.DAY) {
            response = await (0, autoAIRequest_1.autoAIGetRequest)(branchId, userId, start);
        }
        else {
            if (!end) {
                return { state: undefined, notesJapanese: "" };
            }
            response = await (0, autoAIRequest_1.autoAIGetRequest)(branchId, userId, start, end);
        }
        const t = response?.task;
        const state = t?.State;
        // Check if task is stale (State === 0 and the created time is older than a minute)
        if (state === autoAI_1.TaskState.Created && t?.Created && isTaskStale(t.Created)) {
            return { state, notesJapanese: "", stale: true };
        }
        let notesJapanese = "";
        if (state === autoAI_1.TaskState.Done && t?.Output) {
            const notes = extractNotesFromOutput(t.Output);
            notesJapanese = notes;
        }
        return { state, notesJapanese };
    }
    catch {
        return { state: undefined, notesJapanese: "" };
    }
}
// We disable the AutoAI button while polling is active, so that users cannot start multiple autoai tasks.
function disableAutoAIBtn(disable) {
    const btn = document.querySelector('#auto-btn');
    if (!btn) {
        return;
    }
    btn.classList.toggle('disabled-auto-btn', disable);
}
function initFooterAutoButtonClick() {
    const btn = document.querySelector('#auto-btn');
    if (!btn) {
        return;
    }
    btn.addEventListener('click', (evt) => {
        if (btn.classList.contains('disabled-auto-btn')) {
            // Prevent dropdown from opening when disabled
            evt.preventDefault();
            evt.stopImmediatePropagation();
            (0, summary_lib_1.openAlertModal)("シフトを作成中は、自動作成ボタンが一時的に無効になります。");
        }
    }, true);
}
